<template>
  <el-card
    id="shipping_card"
    v-loading="isLoadingDay"
    class="check-list box-card"
    :data-id="bid.id"
  >
    <bid-info
      :bid="bid"
      :index="index"
      :is-collapse="showDetails"
      v-on="$listeners"
    />
    <div style="position: relative">
      <el-collapse :value="collapsedBidId" accordion @change="onCollapseChange">
        <el-collapse-item :name="bid.id">
          <template slot="title">
            <span>{{ showDetails ? 'Свернуть' : 'Подробнее' }}</span>
          </template>
          <days-titles v-if="bid.load_days.length">
            <el-col :span="1" class="ta-c">
              <el-checkbox
                v-if="bid.load_days.length && !isLoading"
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              />
            </el-col>
          </days-titles>
          <el-checkbox-group
            v-model="load_days_ids"
            @change="handleCheckedChange"
          >
            <bid-day
              v-for="b in bid.load_days"
              :key="b.id"
              :doc-info="getDay(b.id)"
              :doc-loading="isLoading"
              :day="{ ...b, type_code: bid.type_code }"
              :bid-id="bid.id"
              v-on="$listeners"
            />
          </el-checkbox-group>
          <bid-actions
            v-if="canAction('route_shipping_action')"
            :bid="bid"
            :choosed="load_days_ids"
            :is-archive="isArchive"
            :days-before="daysBefore"
            :is-collapse="showDetails"
            @editRegistry="editRegistry"
            @setHot="setHot"
            @show="showDaysBefore"
            @addBidToLP="addBidToLP"
            @openDialogSaveNomenclature="
              bidId => $emit('openDialogSaveNomenclature', bidId)
            "
            v-on="$listeners"
          />
        </el-collapse-item>
      </el-collapse>
    </div>
  </el-card>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDate } from '@/datas/DateFormats'
import { getNow, isAfterDay } from '@/helpers/date'
import { mapGetters } from 'vuex'
import BidActions from './BidActions'
import BidDay from './BidDay/index'
import BidInfo from './BidInfo/index'
import DaysTitles from './DaysTitles'

const LoadDay = RepositoryFactory.get('loadDay')

export default {
  name: 'ShippingItem',
  components: { BidDay, BidInfo, BidActions, DaysTitles },
  props: {
    curBid: {
      type: Object,
      default: () => {},
    },
    isArchive: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      daysBefore: false,
      isLoading: false,
      docs: [],
      load_days_ids: [],
      checkAll: false,
      isIndeterminate: false,
      showDetails: false,
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoadingDay() {
      return this.getLoading('Day')
    },
    collapsedBidId() {
      return this.showDetails ? this.curBid.id : 0
    },
    bid() {
      const getTime = date => new Date(date).getTime()
      let list
      let countAuto = 0
      const loadDays = []
      const currentDay = getNow(defaultDate)
      const afterDateMoment = isAfterDay(currentDay)

      if (this.curBid.load_days) {
        this.curBid.load_days.map(d => {
          countAuto += d.responses_count_total

          if (!this.daysBefore && !afterDateMoment(d.load_date)) {
            return false
          }
          loadDays.push(d)
        })
        const sortedLoadDays = loadDays.sort(
          (a, b) => getTime(a.load_date) - getTime(b.load_date),
        )

        list = { ...this.curBid, load_days: sortedLoadDays, countAuto }
      }

      return list ? list : this.curBid
    },
  },
  watch: {
    load_days_ids(newVal) {
      this.$emit('handleSelectedLoadDaysIds', newVal)
    },
  },
  mounted() {
    if (this.bid.is_tudatka) {
      this.getDocCount()
      this.showDetails = true
    }
    this.$nextTick(() => this.$emit('ready'))
  },
  methods: {
    editRegistry(item) {
      this.$emit('editRegistryItem', item)
    },
    setHot(item) {
      this.$emit('setHotItem', item)
    },
    addBidToLP(item) {
      this.$emit('addBidToLPItem', item)
    },
    showDaysBefore() {
      this.daysBefore = !this.daysBefore
      this.getDocCount()
    },
    getDay(id) {
      return this.docs.find(d => Number(d.load_day_id) === id)
    },
    getDocCount() {
      const ids =
        this.bid && this.bid.load_days ? this.bid.load_days.map(b => b.id) : []

      if (ids.length) {
        this.isLoading = true
        LoadDay.getDocCount(ids)
          .then(res => {
            const { status, data } = res

            if (status === 200 && data) {
              this.docs = data
            }
          })
          .catch(() => this.$message.error('Ошибка получения данных'))
          .finally(() => (this.isLoading = false))
      } else {
        this.docs = []
      }
    },
    onCollapseChange() {
      this.showDetails = !this.showDetails

      if (this.showDetails) {
        this.getDocCount()
      }
    },
    handleCheckAllChange(val) {
      this.load_days_ids = val ? this.bid.load_days.map(e => e.id) : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length

      this.checkAll = checkedCount === this.bid.load_days.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.bid.load_days.length
    },
  },
}
</script>

<style lang="sass">
#shipping_card
  margin-bottom: 20px
  box-shadow: none
  &:hover
    transition: all 0.2s
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12)
  .el-collapse
    border: none
    .el-collapse-item__wrap
      border: none
    .el-collapse-item__header
      color: #409EFF
      position: absolute
      right: 0
      top: -25px
      z-index: 2
      font-size: 14px
      border: none
      height: auto
      &.is-active
        top: auto
        bottom: -5px
        right: 0
        background: transparent
      span
        border-bottom: 1px solid
        line-height: 1
    .el-collapse-item__arrow
      display: none
</style>
